/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleHistorysliderInit = (component) => () => {
    $(component)
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            centerMode: true,
            dots: false,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            nextArrow: '<button class="slick-next slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            variableWidth: true,
            infinite: false,
        });
};

export default handleHistorysliderInit;



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/handleHistorysliderInit.js